import { ReactNode } from "react";
import { Text } from "@chakra-ui/react";

export const Label = ({ children }: { children: ReactNode }) => (
  <Text fontWeight="bold" mt="2">
    {children}
  </Text>
);
